<app-allocation-details
  *ngIf="allocationDataIsLoaded()"
  [allocation]="allocation"
></app-allocation-details>
